import { Box, Stack, Typography } from '@mui/material';
import { formatNumber } from 'src/utils/format-number';
import { formatCurrency } from 'src/utils/format-currency';
import { ClusterMetricColumn, MetricFormat } from '../config';

/** Bar width in %: ratios on their own 0-100 scale, volumes relative to the page maximum. */
export const metricBarWidth = (format: MetricFormat, value: number | null | undefined, max: number): number => {
  if (format === 'percent') return Math.min(value || 0, 100);
  return max > 0 ? ((value || 0) / max) * 100 : 0;
};

export const formatMetric = (column: ClusterMetricColumn, value: any, currency: string | undefined, locale: string): string => {
  if (column.format === 'currency') return formatCurrency(value, currency, locale, true, 2);
  if (column.format === 'percent') return `${(value || 0).toFixed(1)}%`;
  return formatNumber(value);
};

type Props = {
  column: ClusterMetricColumn;
  value: any;
  max: number;
  currency?: string;
  locale: string;
};

/** Value + horizontal bar, the cell of every metric column of the Cluster Manager. */
export default function MetricBarCell({ column, value, max, currency, locale }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} width="100%">
      <Typography sx={{ minWidth: column.valueMinWidth, textAlign: 'right', color: '#333C47', fontWeight: 500, fontSize: '14px' }}>
        {formatMetric(column, value, currency, locale)}
      </Typography>
      <Box sx={{ flex: 1, height: 6, borderRadius: 999, backgroundColor: 'transparent', overflow: 'hidden' }}>
        <Box
          sx={{
            width: `${metricBarWidth(column.format, value, max)}%`,
            height: '100%',
            borderRadius: 999,
            backgroundColor: column.barColor,
          }}
        />
      </Box>
    </Stack>
  );
}
